import { lazy } from "react";

const CallAssignmentsPage = lazy(() => import("./pages/CallAssignmentsPage"));

export const callAssignmentsRoutes = [
  { path: "/call-assignments", element: <CallAssignmentsPage /> },
];
